import React from 'react'
import { Form, Input } from 'antd';
import FormControls from '../../../../../components/form/FormControls/FormControls';

type DurationFormInputsProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    clearForm?: () => void
    resetChanges?: () => void
    submitForm: () => void
}

export const DurationFormInputs: React.FC<React.PropsWithChildren<DurationFormInputsProps>> = (props) => {
    const {
        handleChange, clearForm, submitForm,
        resetChanges,
    } = props

    return (
        <>
            <Form.Item
                name="name"
                label="Название"
                className="uif-ant-form-item"
            >
                <Input onInput={handleChange} />
            </Form.Item>

            <FormControls
                submitForm={submitForm}
                resetChanges={resetChanges}
                clearForm={clearForm}
            />
        </>
    )
}

export default DurationFormInputs